





























































































































































    import AbpBase from "@/lib/abpbase";
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import {
        GetPackageList,
        GetConList,
        GetItemList,
        GetMedList,
        GetPackageDetailList,
        SaveStandOrders,
        GetStandOrders,
        GetTempOrders,
        EditTempOrder,
        EditStandOrder,
        SaveTemOrders,
        DeleteOrder,
        ChangeStandToTempOrder,
        GetUserRoles,
        OperateOrder
    } from '@/api/dialysisProcess'

    import {GetListByCode} from '@/api/configureDictionary/'
    import YzModel from './makeAdviceForm'
    import u from 'underscore'

    @Component({
        components:{}
    })
    export default class  extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop({type:Object,default:{}}) data:any;
        //价格合计
        @Watch('list')
        watchList(val:any,oldval:any){
            let amountValues = this.list.map((item:any) => Number(item.price*item.quantity))
            let medAmountValues = this.list.map((item:any)=>{if(item.itemType==3){return Number(item.price*item.quantity)}})
            let proAmountValues = this.list.map((item:any)=>{if(item.itemType==1){return Number(item.price*item.quantity)}})
            let conAmountValues = this.list.map((item:any)=>{if(item.itemType==2){return Number(item.price*item.quantity)}})
            this.amountInfo.amount = amountValues.reduce((prev:any, curr:any) => {
				if (!isNaN(curr)) {
					return prev + curr
				} else {
					return prev
				}
            }, 0)
            this.amountInfo.medAmount = medAmountValues.reduce((prev:any, curr:any) => {
				if (!isNaN(curr)) {
					return prev + curr
				} else {
					return prev
				}
            }, 0)
            this.amountInfo.proAmount = proAmountValues.reduce((prev:any, curr:any) => {
				if (!isNaN(curr)) {
					return prev + curr
				} else {
					return prev
				}
            }, 0)
            this.amountInfo.conAmount = conAmountValues.reduce((prev:any, curr:any) => {
				if (!isNaN(curr)) {
					return prev + curr
				} else {
					return prev
				}
			}, 0)
			//保留两位小数
			this.amountInfo.amount = Number(this.amountInfo.amount.toFixed(2))
			this.amountInfo.medAmount = Number(this.amountInfo.medAmount.toFixed(2))
			this.amountInfo.proAmount = Number(this.amountInfo.proAmount.toFixed(2))
			this.amountInfo.conAmount = Number(this.amountInfo.conAmount.toFixed(2))
        }
        
        //价格
        amountInfo:any = {
            amount:0,
            medAmount:0,
            proAmount:0,
            conAmount:0,
        }
        roleName = ''
        //获取用户角色
        async getUserRoles(){
            let res = await GetUserRoles()
            this.roleName = res.objects[0].roleName
        }


        //左右tabs
        tabsShow = 2
        tabsChange(type:any){
            this.adviceType = 1;
            this.tabsShow = type;
            this.renderColumns()
            if(this.adviceType == 1){
                this.getData()
            }else{
                //表格清空；
                this.form.itemType = 3;
                this.typeChange()
            }
        }
        //医嘱选择
        adviceType = 1
        form:YzModel = new YzModel()
        //周期频率
        zqplShow = 1
        //周列表
        weekList = ['周一','周二','周三','周四','周五','周六','周日',]
        weekNow = []
        weekLast = []
        //类型
        itemType = 3; 
        itemTypeOptions = [
            {value:3,text:'药品'},
            {value:1,text:'项目'},
            {value:2,text:'耗材'},
            {value:4,text:'组套'},
        ]
        //表格数据
        list:any =[]
        isStopList:any =[]
        table:any = {
            loading:false,
        }
        itemInfo:any = {};
        //用法
        usageOptions=[]
        //每次用量单位
        dosageUnitOptions:any=[]
        //频次
        frequencyOptions=[]
        //总量单位
        unitOptions:any=[]
        //项目
        itemOptions = []
        //根据项目ID带出单位等信息 （list)
        itemList = []
        //项目耗材药品远程加载
        itemLoading:Boolean = false;
        //药品耗材无用法频次信息。不可用状态
        itemDisabled:Boolean = false;

        created() {
            console.log(this.data)
            this.getUserRoles()
            this.getData()
            this.getSelects()  
        }
        //获取下拉框加载
        async getSelects(){
            this.usageOptions = await GetListByCode({input:'008'})
            this.frequencyOptions = await GetListByCode({input:'033'})
        }
        //药品项目耗材检索
        async remoteMethodItem(query:any){
            let str = (this.$refs['setSelect'] as any).$data.query;
            if (str) {
            //赋值为空
                (this.$refs['setSelect'] as any).query = ''
            }
            this.itemOptions = [];
            if (query !== '') {
                this.itemLoading = true;
                let data = {
                    queryStr:query,
                }
                let data2 = {
                    QueryString:query,
                    Page:1,
                    PageSize:9999
                }
                let res:any;
                switch(this.form.itemType){
                    case 3:
                    res= await GetMedList(data)
                    break;
                    case 1:
                    res= await GetItemList(data2)
                    break;
                    case 2:
                    res= await GetConList(data)
                    break;
                    case 4:
                    res= await GetPackageList(data2)
                    break;
                }
                setTimeout(() => {
                    this.itemLoading = false;
                    let list;
                    switch(this.form.itemType){
                        case 3:
                        this.itemList = res.objects;
                        list = res.objects.map((item:any) => {
                            return {
                                id: item.itemId,
                                name: item.itemName
                            }
                        });
                        break;
                        case 1:
                        this.itemList = res.data.items;
                        list = res.data.items.map((item:any) => {
                            return {
                                id: item.itemId,
                                name: item.itemName
                            }
                        });
                        break;
                        case 2:
                        this.itemList = res.objects;
                        list = res.objects.map((item:any) => {
                            return {
                                id: item.itemId,
                                name: item.itemName
                            }
                        });
                        break;
                        case 4:
                        this.itemList = res.data.items;
                        list = res.data.items.map((item:any) => {
                            return {
                                id: item.itemGroupId,
                                name: item.itemGroupName
                            }
                        });
                        break;
                    }
                    this.itemOptions = list
                }, 200);
            
            } else {
                this.itemOptions = [];
            }
        }
        //带出药品项目耗材信息
        getItemInfo(){
            if(this.form.itemId){
                this.itemList.forEach((item:any) => {
                    if(this.form.itemId == item.itemId){
                        switch(this.form.itemType){
                            case 3:
                            this.form.dosageUnit = item.baisicUnit
                            this.form.unit = item.packingUnit
                            this.unitOptions = [
                                {
                                    id: Number(item.baisicUnit),
                                    meterName: item.baisicUnitName
                                },
                                {
                                    id: Number(item.packingUnit),
                                    meterName: item.packingUnitName
                                }
                            ]
                            //药品计量单位带出
                            this.itemInfo = item;
                            this.form.itemName = item.itemName
                            this.form.price = item.price
                            break;
                            case 1:
                            //项目单位选择项
                            this.itemInfo = item;
                            this.unitOptions = [{id:Number(item.basicUnit),meterName:item.basicUnitName}]
                            this.form.unit = Number(item.basicUnit)
                            this.form.itemName = item.itemName
                            this.form.price = item.price
                            break;
                            case 2:
                            //耗材单位选择项
                            this.itemInfo = item;
                            this.unitOptions = [{id:Number(item.basicUnit),meterName:item.basicUnitName}]
                            this.form.unit = Number(item.basicUnit)
                            this.form.itemName = item.itemName
                            this.form.price = item.price
                            break;
                            case 4:
                            //组套
                            this.itemInfo = item;
                            break;
                        }
                    }
                });
            }
        }
        //类型切换
        typeChange(){
            let str = (this.$refs['setSelect'] as any).$data.query;
            if (str) {
            //赋值为空
                (this.$refs['setSelect'] as any).query = ''
            }
            //类型赋值空
            let str_type = (this.$refs['typeSelect'] as any).$data.query;
            if (str_type) {
            //赋值为空
                (this.$refs['typeSelect'] as any).query = ''
            }
            this.itemType = this.form.itemType;
            this.itemList = []
            this.itemOptions = []
            //初始化
            this.form = new YzModel()
            this.form.itemType = this.itemType;

            switch(this.form.itemType){
                case 3:
                this.itemDisabled = false
                //更改表单验证
                this.rules.usage[0].required = true;
                this.rules.dosage[0].required = true;
                this.rules.dosageUnit[0].required = true;
                this.rules.frequency[0].required = true;
                this.rules.days[0].required = true;
                this.rules.quantity[0].required = true;
                this.rules.unit[0].required = true;
                break;
                case 1:
                this.itemDisabled = true
                //更改表单验证
                this.rules.usage[0].required = false;
                this.rules.dosage[0].required = false;
                this.rules.dosageUnit[0].required = false;
                this.rules.frequency[0].required = false;
                this.rules.days[0].required = false;
                this.rules.quantity[0].required = true;
                this.rules.unit[0].required = true;
                break;
                case 2:
                this.itemDisabled = true
                //更改表单验证
                this.rules.usage[0].required = false;
                this.rules.dosage[0].required = false;
                this.rules.dosageUnit[0].required = false;
                this.rules.frequency[0].required = false;
                this.rules.days[0].required = false;
                this.rules.quantity[0].required = true;
                this.rules.unit[0].required = true;
                //类型名称
                break;
                case 4:
                this.itemDisabled = true
                //更改表单验证
                this.rules.usage[0].required = false;
                this.rules.dosage[0].required = false;
                this.rules.dosageUnit[0].required = false;
                this.rules.frequency[0].required = false;
                this.rules.days[0].required = false;
                this.rules.quantity[0].required = false;
                this.rules.unit[0].required = false;
                //类型名称
                break;
            }
        }
        //添加
        async add(){
            (this.$refs.form as any).validate(async (valid:boolean)=>{
                if(valid){
                    //组套时加载明细
                    if(this.form.itemType==4){
                        let res = await GetPackageDetailList({itemGroupId:this.form.itemId})
                        res.objects.forEach((item:any)=>{
                            item.unit = item.packageUnit
                            item.unitName = item.packageUnitName
                        })
                        this.list.push(...res.objects)
                    }
                    if(this.form.itemType==3){
                        //频次用法名称
                        this.form.usageName = this.getName(this.form.usage,this.usageOptions).text;
                        this.form.frequencyName = this.getName(this.form.frequency,this.frequencyOptions).text;
                        //单位名称
                        this.form.dosageUnitName = this.getName(this.form.dosageUnit,this.unitOptions).meterName;
                    }
                    if(this.form.itemType != 4){
                        this.form.unitName = this.getName(this.form.unit,this.unitOptions).meterName;
                    }
                    //周次频率
                    if(this.tabsShow == 2){
                        if(this.form.cycleList){
                            this.form.cycle = this.form.cycleList.join(';');
                        }
                        if(this.form.nextWeekCycleList){
                            this.form.nextWeekCycle= this.form.nextWeekCycleList.join(';');
                        }
                    }
                    //类型
                    this.form.typeName = this.form.itemType == 3 ? '药品':this.form.itemType == 1 ? '项目':this.form.itemType == 4 ?'组套':'耗材'
                    this.form.$isEdit = false
                    this.form.$checked = false
                    this.form.$disabled = false
                    //添加患者iD
                    this.form.patientId = this.data.id
                    let list = Object.assign({},this.form)
                    if(this.form.itemType!=4){
                        this.list.push(list)
                    }
                    //类型赋值空
                    let str_type = (this.$refs['typeSelect'] as any).$data.query;
                    if (str_type) {
                        (this.$refs['typeSelect'] as any).query = ''
                    }
                    //初始化model
                    this.form = new YzModel()
                    this.form.itemType = this.itemType;
                }
            })
            console.log(JSON.stringify(this.list))
        }
        //根据id，匹配name
        getName(id:any,list:any):any{
            let r;
            list.forEach((item:any) => {
                if(id == item.id){
                    r = item
                }
            })
            return r
        }
        handleSave(row:any){
            if(row.id){
                this.edit(row)
            }
            this.$set(row, '$isEdit', false)
        }
        handleEdit(row:any){
            
            this.$set(row, '$isEdit', true)
        }
        async edit(data:any){
            let res;
           
            res = await EditStandOrder(data)
            if(res.status == 1){
                this.getData()
            }
        }
        //转临时
        async changeStandToTempOrder(data:any){
            let res = await ChangeStandToTempOrder(data)
            if(res.status == 1){
                this.adviceType = 1
                this.getData()
            }
        }
        changeStand(){
            let filterCheck = this.list.filter((item:any)=> {return item.$checked})
            if(filterCheck.length==0){
                this.$Message.info('请选择')
                return false
            }
            let data = {
                dialysisSignId:this.data.dialysisSignId,
                standOrders:filterCheck
            }
            this.changeStandToTempOrder(data)
        }
        rowChangeStand(row:any){
            let data = {
                dialysisSignId:this.data.dialysisSignId,
                standOrders:[row]
            }
            this.changeStandToTempOrder(data)
        }
        async save(){
            if(this.adviceType == 1){
                return false
            }
            if(this.list.length==0){
                this.$Message.info('请添加医嘱')
                return false;
            }
            let res;
            if(this.tabsShow == 1){
                res = await SaveTemOrders(this.list)
            }else{
                res = await SaveStandOrders(this.list)
            }
            if(res.status==1){
                this.adviceType = 1
                this.getData()
            }
            console.log(res)
        }
        //获取列表
        async getData(){
            this.table.loading = true
            let data = {
                patientId:this.data.id,
                isStop:false,
            }
            let res;
            let res2;
            if(this.tabsShow == 1){
                res = await GetTempOrders(data)
            }else{
                res = await GetStandOrders(data)
                data.isStop = true
                res2 = await GetStandOrders(data)
                this.isStopList = []
                this.groupList(res2.objects,this.isStopList)
            }
            this.list = []
            this.groupList(res.objects,this.list)

            this.renderColumns()
            this.table.loading = false
        }
        groupList(list:any,mblist:any){
            //根据组号分组
            let group_obj= u.groupBy(list,function(value:any, key:any, list:any){return list[key].groupNo})
            //遍历
            for(var key in group_obj){
                for(var i = 0; i<group_obj[key].length;i++){
                    let item:any = Object.assign(new YzModel(),group_obj[key][i])
                    if(item.groupNo != 0){
                        if(group_obj[key].length==1){
                            item.groupClass=0
                        }else{
                            item.groupClass = i==0?1:item.groupClass = i==group_obj[key].length-1?3:2
                        }
                    }else{
                        item.groupClass=0
                    }
                    let list = Object.assign({},item)
                    mblist.push(list)
                }
            }
        }
        cancel(){
            this.$emit('input',false);
            this.$emit('on-back')

        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
                this.$emit('on-back')
            }
        }
        //组号标记
        getGroupClass(no:any){
            let style = {}
            switch(no){
                case 0:
                style = {}
                break;
                case 1:
                style = {width: '11px',height: '18px',borderTop:'3px solid #e5355b',borderRight:'3px solid #e5355b'}
                break;
                case 2:
                style = {width: '11px',height: '24px',borderRight:'3px solid #e5355b'}
                break;
                case 3:
                style = {width: '11px',height: '18px',borderBottom:'3px solid #e5355b',borderRight:'3px solid #e5355b'}
                break;
            }
            return style;
        }
        columns:any =[]
        renderColumns(){
            this.columns = [
                {
                    title: ' ',
                    width:50,
                    render: (h: any, params: any) => {
                        let self = this;
                        return h('Checkbox',{
                            props: {
                                disabled:params.row.$disabled,
                                value:params.row.$checked,
                            },
                            on:{
                                'on-change':(val:any)=>{
                                    this.checkChange(params.add,val)
                                    // this.$set(params.row, '$checked', val)
                                }
                            }
                        })
                    }
                },
                {
                    title: "类型",
                    key: 'typeName'
                },{
                    title: "医嘱名称",
                    key: 'itemName'
                },{
                    title: "组",
                    key: 'groupClass',
                    width:60,
                    className: 'demo-table-redline-column',
                    render: (h: any, params: any) => {
                        return h('div',{
                            style:this.getGroupClass(params.row.groupClass)
                        })
                    }
                },{
                    title: "每次量",
                    key: 'dosage',
                    render: (h:any, params:any) => {
                        if (params.row.$isEdit) {
                            return h('Input', {
                            props: {
                                value: params.row.dosage
                            },
                            on: {
                                input: function (value:any) {
                                    params.row.dosage = value
                                }
                            }
                            });
                        } else  {
                            return h('div', params.row.dosage);
                        }
                    }
                },{
                    title: "单位",
                    key: 'dosageUnitName'
                },{
                    title: "用法",
                    key: 'usageName'
                },{
                    title: "频率",
                    key: 'frequencyName'
                },{
                    title: "天数",
                    key: 'days',
                    render: (h:any, params:any) => {
                        if (params.row.$isEdit) {
                            return h('Input', {
                            props: {
                                value: params.row.days
                            },
                            on: {
                                input: function (value:any) {
                                    params.row.days = value
                                }
                            }
                            });
                        } else  {
                            return h('div', params.row.days);
                        }
                    }
                },{
                    title: "总量",
                    key: 'quantity',
                    render: (h:any, params:any) => {
                        if (params.row.$isEdit) {
                            return h('Input', {
                            props: {
                                value: params.row.quantity
                            },
                            on: {
                                input: function (value:any) {
                                    params.row.quantity = value
                                }
                            }
                            });
                        } else  {
                            return h('div', params.row.quantity);
                        }
                    }
                },{
                    title: "单位",
                    key: 'unitName'
                },{
                    title: "本周周期",
                    key: 'cycle'
                },{
                    title: "下周周期",
                    key: 'nextWeekCycle'
                },{
                    title: "操作",
                    width:this.tabsShow == 1?150:220,
                    render: (h: any, params: any) => {
                        let vm = this;
                        let deleteTel = this.tabsShow == 1?null:h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.deleteRow(params.add)
                                    }
                                }
                            }, this.adviceType==2?'移除':'停止')
                        let editTel = this.tabsShow == 1? null : h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        if (params.row.$isEdit) {
                                            this.handleSave(params.row)
                                        } else {
                                            this.handleEdit(params.row)
                                        }
                                    }
                                }
                            }, params.row.$isEdit ? '保存' : '修改')     
                        let lsTel = this.tabsShow != 1 && this.adviceType != 2? h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: async () => {
                                        this.$Modal.confirm({
                                            title:'提示',
                                            content:`是否确认对患者${vm.data.patientName}核对医嘱</br>
                                                    ${params.row.itemName}  ${params.row.quantity}  ${params.row.unitName}  ${params.row.usageName}  ${params.row.frequencyName}`,
                                            onOk:async ()=>{
                                                let data:any = {
                                                    type:1,
                                                    operateType:null,
                                                    checkTime:new Date(params.row.checkTime),
                                                    exeTime:new Date(params.row.exeTime),
                                                    id:params.row.id,
                                                }
                                                if (!params.row.checkUserId &&!params.row.exeUserId ) {
                                                    data.operateType = 0
                                                } else if(params.row.checkUserId &&!params.row.exeUserId ){
                                                    data.operateType = 1
                                                }else{
                                                    data.operateType = 3
                                                }
                                                let res = await OperateOrder(data)
                                                if(res.status==1){
                                                    this.getData()
                                                }
                                            }
                                        })
                                        
                                    }
                                }
                            }, '核对'):null;                 
                        return h('div', [
                            editTel,
                            deleteTel
                        ])
                    }
                },
            ]
            if(this.tabsShow==1){
                this.columns.splice(13,1)
                this.columns.splice(12,1)
                this.columns.splice(11,1)
            }else{
                if(this.roleName == '护士'){
                    this.columns.splice(13,1)
                }
            }
            if(this.adviceType!=2){
                this.columns.splice(0,1)
            }
        }
        columns2 = [
            {
                title: "类型",
                key: 'typeName'
            },{
                title: "医嘱名称",
                key: 'itemName'
            },{
                title: "组",
                key: 'groupClass',
                width:60,
                className: 'demo-table-redline-column',
                render: (h: any, params: any) => {
                    return h('div',{
                        style:this.getGroupClass(params.row.groupClass)
                    })
                }
            },{
                title: "每次量",
                key: 'dosage',
            },{
                title: "单位",
                key: 'dosageUnitName'
            },{
                title: "用法",
                key: 'usageName'
            },{
                title: "频率",
                key: 'frequencyName'
            },{
                title: "天数",
                key: 'days',
            },{
                title: "总量",
                key: 'quantity',
            },{
                title: "单位",
                key: 'unitName'
            },{
                title: "本周周期",
                key: 'cycle'
            },{
                title: "下周周期",
                key: 'nextWeekCycle'
            }
        ]
        //成组逻辑
        checkChange(index:any,val:any){
            let checked = false;
            this.list.forEach((item:any,i:any)=>{
                this.list[index].$checked = val
                if(val){
                    if(this.list[index].groupNo!=0){
                        item.$disabled = item.groupNo!=this.list[index].groupNo?true:false;
                        if(item.groupNo == this.list[index].groupNo){
                            item.$checked = true
                        }
                    }else{
                        item.$disabled = item.groupNo!=0?true:false;
                    }
                }else{
                    if(this.list[index].groupNo!=0){
                        if(item.groupNo == this.list[index].groupNo){
                            item.$checked = false
                        }
                    }  
                }
                if(item.$checked){
                    checked = item.$checked
                }
            })
            if(!checked){
                this.list.forEach((item:any)=>{
                    item.$disabled = false
                })
            }
        }
        cp(){
            let filterGroupNo = this.list.filter((item:any)=> {return item.groupNo!=0 && item.$checked})
            let filterCheck = this.list.filter((item:any)=> {return item.$checked})
            if(filterCheck.length<2){
                this.$Message.info('最少选择两项')
                return false
            }
            if(filterGroupNo.length>0){
                this.$Message.info('已经成组')
                return false
            }
            let newList:any = []
            //记录第一个最后一个划分组线
            let checkJs = 0;
            this.list.forEach((item:any,index:any) => {
                if(item.$checked){
                    checkJs++;
                    if(checkJs==1){
                        item.groupClass = 1
                    }else if(checkJs == filterCheck.length){
                        item.groupClass = 3
                    }else{
                        item.groupClass = 2
                    }
                    item.groupNo = Date.now()
                    item.groupNo = Number(item.groupNo.toString().substring(4))
                    newList.push(item)
                }
            });
            this.list.forEach((item:any,index:any) => {
                if(!item.$checked){
                    newList.push(item)
                }
                item.$checked = false
                item.$disabled = false
            });
            this.list = newList
            this.renderColumns()
            this.$Message.success('成组成功')
        }
        checp(){
            let filterGroupNo = this.list.filter((item:any)=> {return item.groupNo!=0 && item.$checked})
            let filterCheck = this.list.filter((item:any)=> {return item.$checked})
            if(filterCheck.length==0){
                this.$Message.info('请选择已成组项')
                return false
            }
            if(filterGroupNo.length==0){
                this.$Message.info('还没成组')
                return false
            }
            this.list.forEach((item:any,index:any) => {
                if(item.$checked){
                    item.groupNo = 0
                    item.groupClass = 0
                }
                item.$checked = false
                item.$disabled = false
            });
            this.$Message.success('撤销成功')
        }
        //移除行
        deleteRow(index:any) {
            this.$Modal.confirm({
                title:'提示',
                content:`是否确认${this.adviceType!=2?'停止':'删除'}`,
                onOk:async ()=>{
                    if(this.list[index].id){
                        let data = {
                            type:0,
                            operateType:2,
                            id:this.list[index].id,
                        }
                        let res = await OperateOrder(data)
                        if(res.status==1){
                            this.getData()
                        }
                    }else{
                        let x = 0;    //计数 组成员
                        if(this.list[index].groupNo==0){
                            this.list.splice(index, 1);
                        }else{
                            let filterGroupNo = this.list.filter((item:any)=> {return item.groupNo == this.list[index].groupNo})
                            if(filterGroupNo.length == 2){
                                if(this.list[index].groupClass == 1){
                                    this.list[index+1].groupClass = 0
                                    this.list[index+1].groupNo = 0
                                }else if(this.list[index].groupClass == 3){
                                    this.list[index-1].groupClass = 0
                                    this.list[index-1].groupNo = 0
                                }
                            }else{
                                if(this.list[index].groupClass == 1){
                                    this.list[index+1].groupClass = 1
                                }else if(this.list[index].groupClass == 3){
                                    this.list[index-1].groupClass = 3
                                }
                            }
                            
                            this.list.splice(index, 1);
                        }
                    }
                }
            })
        }
        async deleteOrder(data:any){
            let res = await DeleteOrder(data)
            if(res.status==1){
                this.getData()
            }
        }
        
        rules={
            itemType:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            itemId:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            usage:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            dosage:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            dosageUnit:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            frequency:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            quantity:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            unit:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
            days:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/makeAdvice/index.vue